import React from "react";
import {
  Box,
  CardMedia,
  Container,
  makeStyles,
  Typography,
} from "@material-ui/core";
import Slider from "../Swiper/CardsSwiper/Slider.jsx";
import SecondSection from "./Sections/Second/SecondSection";
import ThirdSection from "./Sections/Third/ThirdSection";
import photo1 from "../../assets/swiper1.png";
import photo2 from "../../assets/swiper2.png";
import photo3 from "../../assets/swiper3.png";

const useStyles = makeStyles(({ breakpoints, spacing, mixins }) => ({
  sliderContainer: {
    backgroundColor: "#FEF3E7",
    height: "85vh",
    marginBottom: "50vh",
    [breakpoints.up("xl")]: {
      marginBottom: "35vh",
    },
  },
  imagesContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  imgContainer: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
  },
  img: {
    width: "80%",
  },
  title: {
    margin: `${spacing(2)}px 0 20% 0`,
    fontWeight: "bold",
    fontSize: "36px",
    lineHeight: "100%",
    textAlign: "center",
    color: "	#404040",
    textShadow: " 4px 4px 2px rgba(150, 150, 150, 0.14)",
  },
  offset: mixins.toolbar,
}));

const Home = () => {
  const classes = useStyles();

  const firstCards = (
    <Box component="div" className={classes.imagesContainer}>
      <Box component="div" className={classes.imgContainer}>
        <CardMedia component="img" image={photo1} className={classes.img} />
      </Box>
      <Box component="div" className={classes.center}>
        <Typography variant="h5" className={classes.title}>
          TODO TIPO DE VELAS
        </Typography>
        <Box component="div" className={classes.imgContainer}>
          <CardMedia component="img" image={photo2} className={classes.img} />
        </Box>
      </Box>
      <Box component="div" className={classes.imgContainer}>
        <CardMedia component="img" image={photo3} className={classes.img} />
      </Box>
    </Box>
  );
  const secondCards = (
    <Box component="div" className={classes.imgContainer}>
      <Box component="div" className={classes.imgContainer}>
        <CardMedia component="img" image={photo1} className={classes.img} />
      </Box>
      <Box component="div" className={classes.center}>
        <Typography variant="h5" className={classes.title}>
          TODO TIPO DE VELAS
        </Typography>
        <Box component="div" className={classes.imgContainer}>
          <CardMedia component="img" image={photo2} className={classes.img} />
        </Box>
      </Box>
      <Box component="div" className={classes.imgContainer}>
        <CardMedia component="img" image={photo3} className={classes.img} />
      </Box>
    </Box>
  );

  return (
    <Container>
      <Box component="div" className={classes.sliderContainer}>
        <Box component="div" className={classes.offset} />
        <Slider
          card1={firstCards}
          card2={secondCards}
          className={classes.slider}
        />
      </Box>
      <SecondSection />
      <ThirdSection />
    </Container>
  );
};

export default Home;
